import ErrorsManager from './ErrorsManager';
import { API_ERROR } from './Error';

/**
 * Custom Error class for Server/API failures.
 * Returns a structured ErrorModel via the ErrorsManager factory.
 */
class ServerError extends Error {
    constructor(error: any, messageCustom?: string) {
        // Initialize the base Error with a message
        super(error instanceof Error ? error.message : String(error));

        // Maintain stack trace for V8 engines (Chrome/Node)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ServerError);
        }

        /**
         * Returns the result of ErrorsManager.createError.
         * Cast to 'any' because constructors typically return 'this' implicitly,
         * but this implementation redirects the return value.
         */
        return ErrorsManager.createError({
            type: API_ERROR,
            error,
            messageCustom,
        }) as any;
    }
}

export default ServerError;
